import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";
import Swal from 'sweetalert2'
import { queryClient } from "../../..";

export default async function postUser(value: any, onSuccess: () => void) {
  return await api
  .post(URLS.USER_API, value)
  .then((response) => {
    console.log(response);
      Swal.fire({
        title: "Usuário Cadastrado",
        text: "O usuário foi cadastrado com sucesso!",
        icon: "success",
        position: "center",
        confirmButtonText: "OK",
        confirmButtonColor: "#349946",
        allowOutsideClick: false
      }).then((response) => {
        if(response.isConfirmed) {
          onSuccess();
          queryClient.invalidateQueries();
        }
      });
  })
  .catch((err) => {
    console.log(err);
      // isLoading();
      err.response.status === 500 ?
        Swal.fire({
          title: `Erro de status ${err.response.status}`,
          text: `Ocorreu um erro interno ao cadastrar o usuário. Por favor, entre em contato com um administrador do sistema.`,
          icon: "error",
          position: "center",
          confirmButtonText: "OK",
          confirmButtonColor: "#F27474",
          allowOutsideClick: false
        })
      :
        Swal.fire({
          title: "Erro ao cadastrar usuário",
          text: err.response.data.message,
          icon: "error",
          position: "center",
          confirmButtonText: "OK",
          confirmButtonColor: "#F27474",
          allowOutsideClick: false
        });
  })
}
